module.exports = __webpack_public_path__ + "img/Myanmar.3fb779e9.png";